const KEYCHAIN_KEY = "InventoryShield";

export default class BiometricAuthentication {
  constructor() {
    this.authenticator = window.plugins && window.plugins.touchid;
    this.haveAuthenticator = !!this.authenticator;
    this.isAvailable = false;
    if (this.haveAuthenticator) {
      this.authenticator.isAvailable(
        () => {
          this.isAvailable = true;
        },
        error => {
          console.warn("Biometric authentication not available :(", error);
        }
      );
    }
  }

  async hasCredentialsStoredInKeychain() {
    return await new Promise(resolve => {
      if (this.haveAuthenticator && this.isAvailable) {
        this.authenticator.has(
          KEYCHAIN_KEY,
          function onSuccess() {
            resolve(true);
          },
          function onError() {
            resolve(false);
          }
        );
      } else {
        resolve(false);
      }
    });
  }

  async saveCredentialsToKeychain(credentials) {
    console.log("SAVING CREDENTIALS TO KEYCHAIN", credentials);
    return await new Promise((resolve, reject) => {
      if (this.haveAuthenticator && this.isAvailable) {
        this.authenticator.save(
          KEYCHAIN_KEY,
          credentials,
          function onSuccess() {
            console.log("Successfully saved credentials to the keychain.");
            resolve();
          },
          function onError(errorMessage) {
            console.error(`Error encountered while saving password to keychain: ${errorMessage}`);
            reject(errorMessage);
          }
        );
      } else {
        reject("Biometric Authentication Not Available");
      }
    });
  }

  async deleteCredenialsFromKeychain() {
    return await new Promise((resolve, reject) => {
      if (this.haveAuthenticator && this.isAvailable) {
        this.authenticator.delete(
          KEYCHAIN_KEY,
          function onSuccess() {
            console.log("Successfully deleted any saved credentials from the user's keychain");
            resolve();
          },
          function onError(errorMessage) {
            console.error(`Error encountered while deleting password to keychain: ${errorMessage}`);
            reject(errorMessage);
          }
        );
      } else {
        reject("Biometric Authentication Not Available");
      }
    });
  }

  async getCredentialsFromKeychain() {
    return await new Promise((resolve, reject) => {
      if (this.haveAuthenticator && this.isAvailable) {
        this.authenticator.verify(
          KEYCHAIN_KEY,
          "please verify...",
          function onSuccess(credentialsFromKeychain) {
            console.log(`Retrieved saved credentials`);
            resolve(credentialsFromKeychain);
          },
          function onError(errorCode) {
            const message = `Unable to authenticate biometrically because of error code: ${errorCode}`;
            console.error(message);
            reject(message);
          }
        );
      } else {
        reject("Biometric Authentication Not Available");
      }
    });
  }
}
